import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const PublicLayout = () => {
    return (
        <div className="min-h-screen bg-background text-foreground relative">
            {/* Dot grid texture overlay */}
            <div className="fixed inset-0 dot-grid pointer-events-none z-0" />

            <div className="relative z-10">
                <Navbar />
                <Outlet />
            </div>
        </div>
    );
};

export default PublicLayout;
